import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Team from "@/pages/Team";
import Products from "@/pages/Products";
import Vidyora from "@/pages/Vidyora";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import Careers from "@/pages/Careers";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="noise-bg min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/products" element={<Products />} />
            <Route path="/vidyora" element={<Vidyora />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/careers" element={<Careers />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
